import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { ChargeFormEntry } from 'views/orders/charges/components/GeneralChargesTable/types';

interface Props {
  charge: ChargeFormEntry;
}

export const ChargeEndorsementCodeCard: FC<Props> = ({ charge }) => {
  if (charge.code.match(/^(owners|lenders)_\d+$/)) {
    const code = charge.code.split("_")[1];
    return <Typography>{code}</Typography>;
  }

  return <Typography>-------------</Typography>;
};
